import React, { useContext } from 'react';

import { Container } from 'components/common/Container';
import { LangContext } from 'providers/LangProvider';
import { contact } from 'data/config';
import { Details, Wrapper } from './styles';

export const Footer = () => {
  const { lang } = useContext(LangContext);

  return (
    <Wrapper as="footer">
      <Details as={Container}>
        <p>
          <strong>Hindisvík</strong> · {lang === 'is' ? 'Vatnsnesi, Húnaþingi vestra' : 'Vatnsnes, Northwest Iceland'}
        </p>
        <p>
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </p>
        <p>© {new Date().getFullYear()} Hindisvík</p>
      </Details>
    </Wrapper>
  );
};
